<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex"
        style="height: 100vh; overflow:hidden; padding: 0"
      >
        <b-img
          style="object-fit:cover; height: 100vh; width: 100%"
          fluid
          :src="imgUrl"
          alt="Login V2"
        />
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-link class="brand-logo">
          <h2
            class="brand-text text-primary ml-1"
            style="text-transform: uppercase"
          >
            {{ this.$store.state.app.appConfig.name }}
          </h2>
          <b-col style="width: 25vw; display: flex; flex-direction: row; justify-content: flex-end;">
            <locale />
          </b-col>
        </b-link>
        <!-- Brand logo-->
        <!-- /Brand logo-->
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
            {{ $t('login') }}
          </b-card-title>
          <b-card-text class="mb-2" />

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                :label="$t('email')"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">{{ $t('password') }}</label>
                  <!-- <b-link :to="{name:'auth-forgot-password'}">
                    <small>Forgot Password?</small>
                  </b-link>-->
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!--<b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>-->

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                style="text-transform: uppercase"
                block
                :disabled="invalid || processing"
              >
                {{ $t('login2') }}
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, /* BFormCheckbox , */ BCardText, BCardTitle, BImg, BForm, BButton, VBTooltip,
} from 'bootstrap-vue'
import Locale from '@hw-ui/layouts/components/navigation/navbar-top/components/Locale.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@hw-ui/mixins/ui/forms'
import store from '@/shared/store/index'
import ability from '@hw-core/libs/acl/ability'

import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    // BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    Locale,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      processing: false,

      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.hwUiLayout.skin === 'dark') {
        return require('@hw-ui/assets/images/pages/forgot-password.png')
      }
      if (store.state.app.appConfig.type === 'ow-admin') {
        return require('@hw-ui/assets/images/pages/oiwa-login-banner.png')
      }

      return require('@hw-ui/assets/images/pages/login-banner.jpg')
    },
  },
  beforeCreate() {
    document.title = this.$t('login')
  },
  methods: {
    async login() {
      try {
        this.processing = true
        const isValidated = await this.$refs.loginForm.validate()
        if (isValidated) {
          const authUser = await this.$store.dispatch('appAuth/login', { email: this.userEmail, password: this.password })
          // eslint-disable-next-line no-unused-expressions
          authUser.role === 'admin'
            ? await store.dispatch('appAccount/getAccounts')
            : await store.dispatch('appAccount/getAccount', { accountId: authUser.accountId })

          let abilities = []
          const userAbilities = JSON.parse(JSON.stringify(authUser.abilities))
          const userSubjects = Object.keys(userAbilities)

          if (store.state.appAccount.selectedAccount.value.subscription && store.state.appAccount.selectedAccount.value.subscription.modules) {
            const subjects = store.state.appAccount.selectedAccount.value.subscription.modules.concat(userSubjects)
            abilities = subjects.map(subject => ({
              action: 'manage',
              subject,
            }))
          } else {
            abilities = userSubjects.map(subject => ({
              action: 'manage',
              subject,
            }))
          }

          ability.update(abilities)
          this.$router.push('/')
        }
      } catch {
        this.processing = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('error'),
            text: this.$t('something_went_wrong'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@hw-ui/scss/vue/pages/page-auth.scss';
</style>
